var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentmethod(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12.4123,
    fill: "#4928FD",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_78_4239",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_78_4239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 25C25.1667 25 24.4583 24.7083 23.875 24.125C23.2917 23.5417 23 22.8333 23 22C23 21.1667 23.2917 20.4583 23.875 19.875C24.4583 19.2917 25.1667 19 26 19C26.8333 19 27.5417 19.2917 28.125 19.875C28.7083 20.4583 29 21.1667 29 22C29 22.8333 28.7083 23.5417 28.125 24.125C27.5417 24.7083 26.8333 25 26 25ZM19 28C18.45 28 17.9792 27.8042 17.5875 27.4125C17.1958 27.0208 17 26.55 17 26V18C17 17.45 17.1958 16.9792 17.5875 16.5875C17.9792 16.1958 18.45 16 19 16H33C33.55 16 34.0208 16.1958 34.4125 16.5875C34.8042 16.9792 35 17.45 35 18V26C35 26.55 34.8042 27.0208 34.4125 27.4125C34.0208 27.8042 33.55 28 33 28H19ZM21 26H31C31 25.45 31.1958 24.9792 31.5875 24.5875C31.9792 24.1958 32.45 24 33 24V20C32.45 20 31.9792 19.8042 31.5875 19.4125C31.1958 19.0208 31 18.55 31 18H21C21 18.55 20.8042 19.0208 20.4125 19.4125C20.0208 19.8042 19.55 20 19 20V24C19.55 24 20.0208 24.1958 20.4125 24.5875C20.8042 24.9792 21 25.45 21 26ZM32 32H15C14.45 32 13.9792 31.8042 13.5875 31.4125C13.1958 31.0208 13 30.55 13 30V19H15V30H32V32Z",
    fill: "#4928FD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentmethod);
export default __webpack_public_path__ + "static/media/Payment method.4524a850d3d2f0267c08342b26d23506.svg";
export { ForwardRef as ReactComponent };